import { render, staticRenderFns } from "./addSampleInfo.vue?vue&type=template&id=680e0180&scoped=true&"
import script from "./addSampleInfo.vue?vue&type=script&lang=js&"
export * from "./addSampleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680e0180",
  null
  
)

export default component.exports